import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "./StaticFunctions";
import Api from "./Api";

class DesignPreviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        designId: PropTypes.string.isRequired
    };

    static defaultProps = {
		designStitches: 0,
        showDesignId: false,
        styles: {}
    };

    constructor(props) {

        super(props);

        this.api = new Api();

    }

    getDesignSrc() {

        const companyId			= this.props.baseData.companies.currentCompany.id;
        const designId			= this.props.designId;
        const designStitches	= this.props.designStitches;
        const hidePattern		= this.props.baseData.companies.currentCompany.hide_patterns;

        if (!hidePattern) return this.api.fileSource({type: 'picto', id_company: companyId, id: designId, stitches: designStitches});

        return StaticFunctions.getImgQuestionMarkSrc();

    }

    getDefaultSrc(event) {

        event.target.src = StaticFunctions.getImgQuestionMarkSrc();

    }

    render() {

        const designId = this.props.designId;
        const showDesignId = (this.props.showDesignId) ? <span>{designId}</span> : null;
        const styles = (this.props.styles) ? this.props.styles : {};
        const patternSrc = this.getDesignSrc();
//console.debug('DesignPreviewContainer render', this.props.designId, this.props.designStitches);
        return (
            <span className="designPreview">
                <img
                    src={patternSrc}
                    alt={""}
                    style={styles}
                    onError={this.getDefaultSrc}
                />

                {showDesignId}
            </span>
        );

    }

}

export default DesignPreviewContainer;